export const RESET = 'USER_UPDATE_RESET';
export const SET_ERROR = 'USER_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'USER_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'USER_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'USER_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'USER_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'USER_UPDATE_UPDATE_RETRIEVED';
export const USER_UPDATE_SET_UPDATE_REFRESH = 'USER_UPDATE_SET_UPDATE_REFRESH';
